<template lang="html">

  <section class="banner-contacto">
    <div class="container-xs">
      <h2 class="title waypoints" data="fadeInUp" v-html="$t('banner_contacto.title')"></h2>
      <router-link class="btn-rounded-red waypoints" data="fadeInUp" :to="$t('enlaces.contacto')" v-html="$t('banner_contacto.contacta')"></router-link>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-contacto',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped >
.banner-contacto {
  width: 100%;
  padding: 120px 50px;
  background: url(/static/img/imagen-banner-contacto.jpg) center/cover no-repeat;
  background-attachment: fixed;
}

.title{
  color: #fff;
  margin-bottom: 30px;
  opacity: 0;
}

@media screen and (max-width: 600px){
  .banner-contacto{
    padding: 50px 20px;
    background-attachment: inherit;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/banner-contacto.vue